import { jsonMember, jsonObject } from 'typedjson';
import { Id } from '@shared/types/id';

@jsonObject
export class EquipmentReportParameterResponse {
  @jsonMember({ name: 'parameterId' }) readonly id!: Id;
  @jsonMember readonly name!: string;
  @jsonMember readonly value!: string;
}
